module.exports = "<span [class]=\"statusStyle\"></span> {{ value }}\r\n"